module.exports = __webpack_public_path__ + "media/notexist.3062aca9.mp3";